/** Ранее проведённые распределения для вкладки «История распределений» */
import { operationsJournalMock } from "../../OperationsJournal/mock/operationsJournalMock";
import { RECIPIENT_PROJECTS } from "./recipientProjectsMock";
import { BASE_ARTICLES } from "./allocationBaseMock";
import { EMPTY_BASE, calculateAllocation } from "../utils/allocationBase";
import { buildAllocationRecord } from "../utils/allocationRecord";

const FIRST_ID = 417;

const pick = (items, ids) => items.filter((item) => ids.includes(item.id));

const withArticles = (method, articles) => ({
  ...EMPTY_BASE,
  method,
  articles: { ...EMPTY_BASE.articles, [method]: articles },
});

/** От старых к новым; две записи за один период — чтобы было видно, что действия их не смешивают */
const HISTORY_PLAN = [
  {
    date: "30.06.2026",
    time: "18:05",
    author: "Петрова М.А.",
    operationIds: [5],
    projectIds: [4, 10],
    base: { ...EMPTY_BASE, method: "manual", manualShares: { 4: "70", 10: "30" } },
  },
  {
    date: "31.07.2026",
    author: "Иванов И.И.",
    time: "16:20",
    operationIds: [12, 18, 22],
    projectIds: [1, 3, 6, 7],
    base: withArticles("dds", BASE_ARTICLES.dds.slice(0, 1)),
  },
  {
    date: "31.07.2026",
    author: "Петрова М.А.",
    time: "17:02",
    operationIds: [2, 8],
    projectIds: [1, 2],
    base: EMPTY_BASE,
  },
  {
    date: "31.08.2026",
    time: "11:15",
    author: "Иванов И.И.",
    operationIds: [15, 25],
    projectIds: [6, 11, 12],
    base: withArticles("balance", BASE_ARTICLES.balance.slice(0, 2)),
  },
  {
    date: "31.08.2026",
    time: "17:40",
    author: "Иванов И.И.",
    operationIds: [1, 11, 21],
    projectIds: [1, 2, 3],
    base: withArticles("opiu", BASE_ARTICLES.opiu.slice(5, 7)),
  },
];

export const INITIAL_ALLOCATION_HISTORY = HISTORY_PLAN.map((plan, index) => {
  const operations = pick(operationsJournalMock, plan.operationIds);
  const projects = pick(RECIPIENT_PROJECTS, plan.projectIds);
  const total = operations.reduce((sum, operation) => sum + operation.amount, 0);
  return buildAllocationRecord({
    id: FIRST_ID + index,
    date: plan.date,
    time: plan.time,
    author: plan.author,
    operations,
    allocation: calculateAllocation(projects, total, plan.base),
    base: plan.base,
  });
}).reverse();
